"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditEventTypes = void 0;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

const CallbackTypes = {
  SAVE_API: "SAVE_API",
  STATUS_API: "STATUS_API",
  EVENT_LISTENER: "EVENT_LISTENER",
  SET_USER_SETTING_API: "SET_USER_SETTING_API",
  GET_USER_SETTING_API: "GET_USER_SETTING_API",
  GET_USER_PROFILE_API: "GET_USER_PROFILE_API",
  GET_FEATURE_FLAG: "GET_FEATURE_FLAG",
  GET_USER_THEME_PREF: "GET_USER_THEME_PREF",
  OPEN_LEGAL_DIALOG_API: "OPEN_LEGAL_DIALOG_API",
  GET_RENDITION_API: "GET_RENDITION_API",
  GET_PUBLIC_PDF_URL: "GET_PUBLIC_PDF_URL",
  GET_FILE_BUFFER_RANGES: "GET_FILE_BUFFER_RANGES",
  GET_IMAGE_BUFFER: "GET_IMAGE_BUFFER",
  GET_INSERT_FILE_BUFFER: "GET_INSERT_FILE_BUFFER",
  EDIT_EVENT_HANDLER: "EDIT_EVENT_HANDLER",
  GET_FILE_PATH: "GET_FILE_PATH",
  GET_SUGGESTION_LIST_API: "GET_SUGGESTION_LIST_API",
  GET_LOCAL_FONT_PRIMING_DIALOG: "GET_LOCAL_FONT_PRIMING_DIALOG",
  GET_VIEWER_ANALYTICS: "GET_VIEWER_ANALYTICS",
  GET_ASSET_VERSION: "GET_ASSET_VERSION",
  WAIT_FOR_DOC_SAVE_COMPLETION: "WAIT_FOR_DOC_SAVE_COMPLETION"
};
const EditEventTypes = exports.EditEventTypes = {
  EDIT_MODE_DISABLED: "EDIT_MODE_DISABLED",
  USER_NOT_LOGGED_IN: "USER_NOT_LOGGED_IN",
  MODERN_VIEWER_DISABLED: "MODERN_VIEWER_DISABLED",
  CLOSE_EDIT: "CLOSE_EDIT",
  EDIT_TRIGGERED: "EDIT_TRIGGERED",
  EDIT_ERROR_EVENTS: "EDIT_ERROR_EVENTS"
};
var _default = exports.default = CallbackTypes;